var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "i-modal",
    {
      ref: "i-modal",
      attrs: {
        closeable: _vm.closeable,
        bgcolor: _vm.mask ? "rgba(0,0,0,0.7)" : "",
      },
      on: {
        opened: function ($event) {
          return _vm.$emit("opened")
        },
        closed: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal el-reset",
          class: [
            _vm.type,
            { "border-none": !_vm.border, "max-height": _vm.maxHeight },
          ],
        },
        [
          _vm.closeBtn
            ? _c(
                "span",
                {
                  staticClass: "close",
                  class: _vm.type,
                  style: { fontSize: _vm.closeBtnSize },
                  on: {
                    click: function ($event) {
                      return _vm.toggleShow(false)
                    },
                  },
                },
                [_vm._v("\n      ×\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.prevBtn
            ? _c(
                "span",
                {
                  staticClass: "prev",
                  class: _vm.type,
                  on: {
                    click: function ($event) {
                      return _vm.$emit("prev")
                    },
                  },
                },
                [
                  _vm._v("\n      ←\n      "),
                  _c("span", { staticClass: "prev-text" }, [
                    _vm._v(_vm._s(_vm.$t("back"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.customBtn
            ? _c(
                "span",
                { staticClass: "customButton" },
                [_vm._t("customBtn")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "overflow" }, [_vm._t("default")], 2),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }